export default {
  id: 'glossary',
  title: 'Pojmovnik',
  icon: 'mdi-book-alphabet',
  show: true,
  order: 16,
  content: () => `
    <h2>Pojmovnik</h2>
    <p>Rječnik najvažnijih pojmova u AI Kasa sustavu.</p>

    <div class="glossary-section">
      <h3>F</h3>
      <dl>
        <dt><strong>Fiskalizacija</strong></dt>
        <dd>
          Proces slanja podataka o izdanom računu u sustav Porezne uprave (FINA).
          Obavezna je za sve račune osim predračuna i ponuda.
        </dd>
      </dl>

      <h3 class="mt-4">J</h3>
      <dl>
        <dt><strong>JIR (Jedinstveni identifikator računa)</strong></dt>
        <dd>
          Jedinstveni broj koji FINA dodjeljuje svakom fiskaliziranom računu.
          Sastoji se od kombinacije brojeva i slova (npr. "a1b2c3d4-e5f6-7890-1234-567890abcdef").
        </dd>
      </dl>

      <h3 class="mt-4">Z</h3>
      <dl>
        <dt><strong>ZKI (Zaštitni kod izdavatelja)</strong></dt>
        <dd>
          Kriptografski kod koji se generira na temelju podataka o računu i certifikata.
          Služi za zaštitu autentičnosti računa.
        </dd>
      </dl>

      <h3 class="mt-4">D</h3>
      <dl>
        <dt><strong>Datum dospijeća</strong></dt>
        <dd>
          Rok do kojeg račun mora biti plaćen. Koristi se kod računa na odgodu plaćanja.
          Nakon isteka roka, račun dobiva status OVERDUE.
        </dd>
      </dl>

      <h3 class="mt-4">P</h3>
      <dl>
        <dt><strong>PDV (Porez na dodanu vrijednost)</strong></dt>
        <dd>
          Porez koji se obračunava na prodajnu cijenu. U Hrvatskoj postoje stope:
          25% (opća stopa), 13% (snižena stopa), 5% (posebna stopa).
        </dd>

        <dt><strong>Primka</strong></dt>
        <dd>
          Skladišni dokument koji evidentira ulaz robe u skladište. Može biti od dobavljača
          ili vlastite proizvodnje.
        </dd>
      </dl>

      <h3 class="mt-4">I</h3>
      <dl>
        <dt><strong>Izdatnica</strong></dt>
        <dd>
          Skladišni dokument koji evidentira izlaz robe iz skladišta.
        </dd>

        <dt><strong>Inventura</strong></dt>
        <dd>
          Popis stvarnog stanja zaliha na skladištu. Može biti potpuna (svi artikli)
          ili parcijalna (odabrani artikli).
        </dd>
      </dl>

      <h3 class="mt-4">M</h3>
      <dl>
        <dt><strong>Međuskladišnica</strong></dt>
        <dd>
          Skladišni dokument za transfer robe između dva skladišta.
        </dd>
      </dl>

      <h3 class="mt-4">N</h3>
      <dl>
        <dt><strong>Normativ</strong></dt>
        <dd>
          Recept za proizvodnju složenog proizvoda. Definira koje sirovine i u kojim
          količinama su potrebne za proizvodnju jedne jedinice gotovog proizvoda.
        </dd>
      </dl>

      <h3 class="mt-4">R</h3>
      <dl>
        <dt><strong>Recapitulacija</strong></dt>
        <dd>
          Zbirni izvještaj o prometu za određeno razdoblje. Prikazuje ukupne iznose
          po načinima plaćanja, PDV stopama i artiklima.
        </dd>

        <dt><strong>Reprezentacija</strong></dt>
        <dd>
          Besplatni računi koji se ne naplaćuju (npr. degustacija, poklon).
        </dd>
      </dl>

      <h3 class="mt-4">S</h3>
      <dl>
        <dt><strong>Storno</strong></dt>
        <dd>
          Poništavanje izdanog računa. Generira se storno račun koji poništava originalni.
        </dd>

        <dt><strong>Skladišna kartica</strong></dt>
        <dd>
          Povijest svih kretanja pojedinog artikla na skladištu: ulazi, izlazi, trenutno stanje,
          prosječna nabavna cijena.
        </dd>
      </dl>
    </div>
  `
}
